import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { db, functions } from '../config/firebase';
import type { ResumoPainel } from '../tipos';

/**
 * O painel lê UM documento, não centenas.
 *
 * O Firestore não faz mediana nem agregação, e a conta do Firebase cresce por
 * leitura. Uma Cloud Function mantém `painel/resumo` atualizado; a tela só
 * escuta. Sem isso, dez pessoas abrindo o painel várias vezes ao dia sairiam
 * da faixa gratuita rápido (7.4 do planejamento).
 */
/**
 * Pede à função que recalcule agora.
 *
 * A agenda reconstrói de 15 em 15 minutos, mas quem acabou de guardar uma
 * oportunidade quer ver o número mudar — esperar o próximo ciclo faria o painel
 * parecer quebrado.
 */
export async function atualizarPainel(): Promise<void> {
  const chamar = httpsCallable<Record<string, never>, unknown>(functions, 'atualizarPainel');
  await chamar({});
}

export function usePainel() {
  const [resumo, setResumo] = useState<ResumoPainel | null>(null);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState<string | null>(null);

  useEffect(() => {
    // Recalcula ao abrir. Falhar aqui não pode derrubar a tela: ela ainda mostra
    // o último resumo gravado, que é melhor que um erro.
    atualizarPainel().catch(() => {});
    return onSnapshot(
      doc(db, 'painel', 'resumo'),
      (snap) => {
        setResumo(snap.exists() ? (snap.data() as ResumoPainel) : null);
        setCarregando(false);
      },
      (e) => {
        setErro(e.message);
        setCarregando(false);
      },
    );
  }, []);

  return { resumo, carregando, erro };
}
